import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch, ref, PropType, onMounted, computed } from 'vue'
import { AccompanyingVisitDetail } from '@/typings/api/yuntuSales'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import { cloneDeep } from 'lodash-es'
import { useRoute } from 'vue-router'
import { selectForNumberValidate } from '@/utils/validate'
import {
  accompanyingVisitCreate, accompanyingVisitDetail,
  accompanyingVisitUpdate,
  getFollowListByRefId
} from '@/api/yuntuSales/superivisorAccompanyingVisit'
import { fetchUsersByWorkCode, listByParamCodes } from '@/api/common'
import { shareInfo } from '@dc-platform/dc-interaction'
import { paramCodesDataFilter } from '@/utils'
import { DcMessage } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import { FormInstance } from 'ant-design-vue'
import { followRecordsDetail } from '@/api/yuntuSales/followUpManage'
import dayjs from 'dayjs'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'


const __default__ = { name: 'DcCosLbuSupervisorAccompanyingVisitBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  data: {
    type: Object as PropType<AccompanyingVisitDetail>
  },
  view: {
    type: Boolean
  },
  valueFormat: {
    type: String,
    default: 'YYYY/MM/DD'
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'view'].includes(value)
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['update:detail', 'getDetail'],
  setup(__props, { emit: __emit }) {

const route = useRoute()
const props = __props
const loading = ref(false)
const customerRecord = ref<any>({})
const resetValue = ref<AccompanyingVisitDetail>({})
const formRef = ref<FormInstance>()
const followList = ref<any[]>([])
const selectedFollow = ref<any>({})
const managerNo = ref<string>()
const emit = __emit
const form = ref<AccompanyingVisitDetail>({
  ccTo: [`${managerNo.value}`]
})
const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
const handleReset = () => {
  console.log(form.value)
  const createTime = form.value.createTime
  form.value = {
    createTime: createTime,
    ccTo: [`${managerNo.value}`]
  }
  followList.value = []
  selectedFollow.value = {}
}
// 校验访客计划表单
const validate = () => {
  Object.values(formRef).forEach((v: any) => {
    if (v) {
      v.validate()
    }
  })
  formRef.value?.validate()
}
watch(
  () => customerRecord.value,
  (val) => {
    if (val.stage === 1) {
      salesClueDetail({ clueId: val.id }).then((res) => {
        const clueDetail = res.data
        if (clueDetail) {
          form.value.dutyBy = clueDetail.followerName
        }
      })
    } else {
      potentialDetail(val.id).then((res) => {
        const customerDetail = res.data
        if (customerDetail && customerDetail.customerInfo != null) {
          form.value.dutyBy = customerDetail.customerInfo.sellerName
        }
      })
    }
  },
  { immediate: true }
)
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
const changeCus = (val: any) => {
  if (val && (props.type === 'add' || props.type === 'edit')) {
    selectedFollow.value = {}
    followList.value = []
    form.value.startTime = ''
    form.value.followId = ''
    fetchFollowList(val)
  }
}
const changeFollow = (v: any) => {
  if (v) {
    selectedFollow.value = followList.value.find((item) => item.id === v)
    selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find((item) => item.id === selectedFollow.value.mode)?.name
    form.value = {
      ...form.value,
      followId: selectedFollow.value.id,
      startTime: selectedFollow.value.startTime
    }
  } else {
    selectedFollow.value = {}
    form.value = {
      ...form.value,
      followId: undefined,
      startTime: undefined
    }
  }
}
const handleMentorChange = () => {
  if (props.type === 'add') getFollowerInfo(shareInfo.getUserInfo().work_code)
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    // if (followerInfo && followerInfo.lbuCustomerRegion != null) {
    //   form.value.mentorRegion = followerInfo.lbuCustomerRegion
    // } else {
    //   form.value.mentorRegion = undefined
    //   setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    // }

    if (followerInfo && followerInfo.managerNo != null) {
      managerNo.value = followerInfo.managerNo
      form.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    accompanyingVisitDetail({ id: route.query.id })
      .then((res) => {
        form.value = res.data ? res.data : {}
        // emit('update:detail', res.data)
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
        fetchFollowList(form.value.cosId)
        if (form.value.followId) {
          fetchFollowDetail(form.value.followId)
        }
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取跟进记录列表
const fetchFollowList = async (refId: any) => {
  getFollowListByRefId(refId).then((res) => {
    followList.value = res.data
  })
}
// 获取跟进记录详情
const fetchFollowDetail = async (id: any) => {
  followRecordsDetail(id)
    .then((res) => {
      const followDetail = res.data
      if (followDetail) {
        selectedFollow.value = followDetail
        selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find((item) => item.id === selectedFollow.value.mode)?.name
      }
    })
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
onMounted(() => {
  handleMentorChange()
  getByParamCodes()
  if (props.type === 'add') {
    const now = dayjs()
    form.value.createTime = now.format(`${props.valueFormat} HH:mm:ss`)
  }
  fetch()
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_accompanying_visit_add' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_accompanying_visit_edit_btn' }
  } else {
    return {}
  }
})
const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...form.value
    }
    try {
      if (props.type === 'edit') {
        await accompanyingVisitUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await accompanyingVisitCreate(p)
        DcMessage.success('新增成功')
      }
      goBack()
    } catch (error) {
    }
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "accompanyingVisitBaseMessage",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "主管共同销售信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户名称",
              name: "cosId",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(ClueAndCustomerSelect, {
                  appId: "cos_lbu",
                  value: form.value.cosId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.cosId) = $event)),
                  label: form.value.customerName,
                  "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerName) = $event)),
                  record: customerRecord.value,
                  "onUpdate:record": _cache[2] || (_cache[2] = ($event: any) => ((customerRecord).value = $event)),
                  disabled: _unref(route).query.followRefId || _unref(route).query.planId ? true : false,
                  onChange: changeCus,
                  view: __props.view
                }, null, 8, ["value", "label", "record", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: "startTime",
              label: "跟进记录",
              rules: [{ validator: _unref(selectForNumberValidate), message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.startTime,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.startTime) = $event)),
                  fieldNames: { label: 'startTime', value: 'id' },
                  options: followList.value,
                  allowClear: "",
                  placeholder: "请选择",
                  onChange: changeFollow,
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "客户负责人",
              name: "dutyBy"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.dutyBy,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.dutyBy) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "创建时间",
              name: "createTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.createTime,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.createTime) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进方式",
              name: "followMode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: selectedFollow.value.followMode,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((selectedFollow.value.followMode) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "联系人",
              name: "contactName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: selectedFollow.value.contactName,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((selectedFollow.value.contactName) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "陪访人",
              name: "lbuAccompanyPerson"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: selectedFollow.value.lbuAccompanyPerson,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((selectedFollow.value.lbuAccompanyPerson) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "下次陪访时间",
              name: "nextVisitTime",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: form.value.nextVisitTime,
                  "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((form.value.nextVisitTime) = $event)),
                  isRange: false,
                  view: __props.view
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "目的",
              name: "lbuPurpose",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: selectedFollow.value.lbuPurpose,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((selectedFollow.value.lbuPurpose) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 2000,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进过程",
              name: "process",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: selectedFollow.value.process,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((selectedFollow.value.process) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 2000,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "当前遇到的问题",
              name: "problem",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: selectedFollow.value.problem,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((selectedFollow.value.problem) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 2000,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "后续",
              name: "result",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: selectedFollow.value.result,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((selectedFollow.value.result) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 2000,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "陪访信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "对销售员的观察",
              name: "process",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.process,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.process) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "对销售员的提升计划",
              name: "followUp",
              rules: [{ required: true, message: '请输入' }],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.followUp,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.followUp) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "抄送人",
              name: "ccTo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: form.value.ccTo,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.ccTo) = $event)),
                  mode: "multiple",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: form.value,
      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form).value = $event)),
      formRef: formRef.value
    }, {
      default: _withCtx(() => [
        (props.type === 'add' || props.type === 'edit')
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (handleSubmit())),
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存 ")
              ]),
              _: 1
            }, 8, ["loading"])), [
              [_directive_permission, permissionPage.value.save]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "formRef"])
  ], 64))
}
}

})